module.exports = __webpack_public_path__ + "img/tablet-icon.a7ba7c13.svg";